export const save = (basketId) => {
  localStorage.setItem('evs.basket', basketId);
};

export const remove = () => {
  localStorage.removeItem('evs.basket');
};

export const get = () => localStorage.getItem('evs.basket');
